module.exports = __webpack_public_path__ + "static/barlgura-3e35684348ee352211f533ab3790fa67.jpg";